import type { TopResultsQuery } from '@graphql/reactQuery';

type SearchResults = NonNullable<TopResultsQuery['search']>;

export function useGetTopSearchResults({
  topSearchResults,
}: {
  topSearchResults: SearchResults | undefined;
}) {
  const hasReleases =
    topSearchResults &&
    topSearchResults.releasesPaginated &&
    topSearchResults.releasesPaginated.edges.length > 0;

  const hasArtists =
    topSearchResults &&
    topSearchResults.artistsPaginated &&
    topSearchResults.artistsPaginated.edges.length > 0;

  const hasPlaylists =
    topSearchResults && topSearchResults.shelves && topSearchResults.shelves.edges.length;

  const hasCollectors =
    topSearchResults && topSearchResults.collectors && topSearchResults.collectors.edges.length > 0;

  const topRelease = hasReleases && topSearchResults.releasesPaginated.edges[0]?.node;

  const topPlaylist = hasPlaylists && topSearchResults.shelves.edges[0]?.node;

  const topArtist = hasArtists && topSearchResults.artistsPaginated.edges[0]?.node;

  const topCollector = hasCollectors && topSearchResults.collectors.edges[0]?.node;

  return {
    hasReleases,
    hasArtists,
    hasPlaylists,
    hasCollectors,
    topRelease,
    topPlaylist,
    topArtist,
    topCollector,
  };
}
